/* Drag-to-scroll orizontal pe containerele .smk-mrow (desktop, cu mouse-ul).
   NU intercepteaza rotita verticala -> scroll-ul vertical al paginii ramane normal.
   Dupa drag, blocheaza click-ul ca sa nu deschida produsul / adauge in cos. */
(function () {
  'use strict';

  function initDrag(el) {
    if (el.dataset.dragInit) return;
    el.dataset.dragInit = '1';

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // touch-ul merge nativ
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      el.classList.add('is-dragging');
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
    });

    el.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startScroll - dx;
    });

    function end(e) {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-dragging');
      try { el.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);

    // dupa un drag real, anuleaza click-ul (sa nu navigheze / adauge in cos)
    el.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('.smk-mrow').forEach(initDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
